import { z, ZodType } from 'zod';
import { User } from './user';
import { userRolesSchema } from './user-role';

export type UserWithPermission = {
	hasMultiLogin: boolean;
} & User;

export const userWithPermissionSchema: ZodType<UserWithPermission> = z.object({
	id: z.number(),
	name: z.string(),
	account: z.object({
		id: z.number(),
		name: z.string(),
	}),
	role: userRolesSchema,
	note: z.string().nullable(),
	isLocked: z.boolean(),
	hasMultiLogin: z.boolean(),
});
